export default __webpack_public_path__ + "media/images/react_icons/instagram-585e0ea6645b9a9f2b8f562a5cb91c13.svg";